import {
  Avatar,
  Box,
  Button,
  Card,
  CardHeader,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteProduct,
  findProducts2,
  updtProdcutImagExtData,
  uploadAdFirstImage,
  uploadAdFourthImage,
  uploadAdSecondImage,
  uploadAdThirdImage,
  uploadImage,
} from "../../../State/Product/Action";

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { styled } from '@mui/material/styles';
import { axiosClouth } from "../../../config/apiConfig";

const ProductsTable = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  //const { customersProduct } = useSelector((store) => store);
  const [filterValue, setFilterValue] = useState({
    availability: "",
    category: "",
    sort: "",
  });

  /*const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
  });*/

  const [productExtData, setProductExtData] = useState({
    altstr1: "",
    altstr2: "",
    altstr3: "",
    altstr4: "",
  });
  
  // query
  const searchParams = new URLSearchParams(location.search);
  const availability = searchParams.get("availability");
  const category = searchParams.get("category");
  const sort = searchParams.get("sort");
  const page = searchParams.get("page");
  const {auth}= useSelector(store=>store);
  const {products}= useSelector(store=>store);
  const [open, setOpen] = useState(false);
  const [openMain, setOpenMain] = useState(false);
  const [opendialog, setOpendialog] = useState(false);
  const [prdid, setPrdid] = useState(null);
  const [state, setState] = useState({
    file: null,
  });
 
  
  const handleDialogOpen = () => {
    setOpendialog(true);
  };

  const handleDialogClose = () => {
    setOpendialog(false);
    //console.log(opendialog);
  };

  const handleClickOpenMain = (productId) => {
    setPrdid(productId);
    setOpenMain(true);
  };

  const handleClickOpen = (productId) => {
    setPrdid(productId);
    setOpen(true);
  };

  const handleCloseMain = () => {
    setOpenMain(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProductExtData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSaveExtData = (e) => {
    e.preventDefault();
    const data={
        productExtData,
        productId: prdid,
        reqJWT: auth?.jwt?.access_token
    }
    dispatch(updtProdcutImagExtData(data));
  };

  const handleClose = (e) => {
    setOpen(false);
  };
  const handleMainFile=(e)=>{
    let file = e.target.files[0]
    setState({file: file})
  }

  const handleMainImage = () => {
    const reqData = {
      reqJWT: auth?.jwt?.access_token,
      productId: prdid,
      file: state.file
    }
    dispatch(uploadImage(reqData));
  }

  const handleAddImageFirst = () => {
    const reqData = {
      reqJWT: auth?.jwt?.access_token,
      productId: prdid,
      file: state.file
    }
    dispatch(uploadAdFirstImage(reqData));
  }

  const handleAddImageSecond = () => {
    const reqData = {
      reqJWT: auth?.jwt?.access_token,
      productId: prdid,
      file: state.file
    }
    dispatch(uploadAdSecondImage(reqData));
  }

  const handleAddImageThird = () => {
    const reqData = {
      reqJWT: auth?.jwt?.access_token,
      productId: prdid,
      file: state.file
    }
    dispatch(uploadAdThirdImage(reqData));
  }

  const handleAddImageFourth = () => {
    const reqData = {
      reqJWT: auth?.jwt?.access_token,
      productId: prdid,
      file: state.file
    }
    dispatch(uploadAdFourthImage(reqData));
  }

  const handlePaginationChange = (event, value) => {
    searchParams.set("page", value - 1);
    const query = searchParams.toString();
    navigate({ search: `?${query}` });
  };

  useEffect(() => {
    // setFilterValue({ availability, category, sort });
    const data = {
      category: category || "",
      colors: [],
      sizes: [],
      minPrice: 0,
      maxPrice: 100000,
      minDiscount: 0,
      sort: sort || "price_low",
      pageNumber: page || 0,
      pageSize: 10,
      stock: availability,
      reqJWT: auth?.jwt?.access_token
    };
    dispatch(findProducts2(data));
  }, [availability, category, sort, page, products?.deleteProduct]);

  const handleFilterChange = (e, sectionId) => {
    //console.log(e.target.value, sectionId);
    setFilterValue((values) => ({ ...values, [sectionId]: e.target.value }));
    searchParams.set(sectionId, e.target.value);
    const query = searchParams.toString();
    navigate({ search: `?${query}` });
  };

  const handleDeleteProduct = (productId) => {
    //console.log("delete product ", productId);
    dispatch(deleteProduct(productId));
  };

  return (
    <Box width={"100%"}>
      {/* <Card className="p-3">
        <CardHeader
          title="Sort"
          sx={{
            pt: 0,
            alignItems: "center",
            "& .MuiCardHeader-action": { mt: 0.6 },
          }}
        />
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Category</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={filterValue.category}
                label="Category"
                onChange={(e) => handleFilterChange(e, "category")}
              >
                <MenuItem value={"pant"}>Men's Pants</MenuItem>
                <MenuItem value={"mens_kurta"}>Men's Kurta</MenuItem>
                <MenuItem value={"saree"}>Saree</MenuItem>
                <MenuItem value={"lengha_choli"}>Lengha Choli</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={4}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">
                Availability
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={filterValue.availability}
                label="Availability"
                onChange={(e) => handleFilterChange(e, "availability")}
              >
                <MenuItem value={"All"}>All</MenuItem>
                <MenuItem value={"in_stock"}>Instock</MenuItem>
                <MenuItem value={"out_of_stock"}>Out Of Stock</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={4}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">
                Sort By Price
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={filterValue.sort}
                label="Sort By Price"
                onChange={(e) => handleFilterChange(e, "sort")}
              >
                <MenuItem value={"price_high"}>Heigh - Low</MenuItem>
                <MenuItem value={"price_low"}>Low - Heigh</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Card> */}

      <Card className="mt-2">
        <CardHeader
          title="All Products"
          sx={{
            pt: 2,
            alignItems: "center",
            "& .MuiCardHeader-action": { mt: 0.6 },
          }}
        />
        {(auth?.user?.firstname && (auth?.user?.role==='ADMIN' || auth?.user?.role==='MANAGER' || auth?.user?.role==='WHOLESALER' || auth?.user?.role==='RETAILER')) ? (
        <TableContainer>
          <Table sx={{ minWidth: 800 }} aria-label="table in dashboard">
            <TableHead>
              <TableRow>
                <TableCell>Image</TableCell>
                <TableCell>Title</TableCell>
                <TableCell sx={{ textAlign: "center" }}>Category</TableCell>
                <TableCell sx={{ textAlign: "center" }}>Price</TableCell>
                <TableCell sx={{ textAlign: "center" }}>Quantity</TableCell>
                <TableCell sx={{ textAlign: "center" }}>Add Main Images</TableCell>
                <TableCell sx={{ textAlign: "center" }}>Add Images</TableCell>
                <TableCell sx={{ textAlign: "center" }}>Delete</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {products?.products?.content?.map((item) => (
                <TableRow
                  hover
                  key={item.name}
                  sx={{ "&:last-of-type td, &:last-of-type th": { border: 0 } }}
                >
                  <TableCell>
                    {" "}
                    <Avatar alt={item.titel} src={item.imageUrl} />{" "}
                  </TableCell>

                  <TableCell
                    sx={{ py: (theme) => `${theme.spacing(0.5)} !important` }}
                  >
                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                      <Typography
                        sx={{
                          fontWeight: 500,
                          fontSize: "0.875rem !important",
                        }}
                      >
                        {item.title}
                      </Typography>
                      <Typography variant="caption">{item.brand}</Typography>
                    </Box>
                  </TableCell>
                  <TableCell sx={{ textAlign: "center" }}>
                    {item.category.name}
                  </TableCell>
                  <TableCell sx={{ textAlign: "center" }}>
                    {item.discountedPrice}
                  </TableCell>
                  <TableCell sx={{ textAlign: "center" }}>
                    {item.quantity}
                  </TableCell>

                  <TableCell sx={{ textAlign: "center" }}>
                    <Button
                      variant="text"
                      onClick={() => handleClickOpenMain(item.productId)}
                    >
                      Add Main Images
                    </Button>
                  </TableCell>

                  <TableCell sx={{ textAlign: "center" }}>
                    <Button
                      variant="text"
                      onClick={() => handleClickOpen(item.productId)}
                    >
                      Add Images
                    </Button>
                  </TableCell>

                  <TableCell sx={{ textAlign: "center" }}>
                    <Button
                      variant="text"
                      onClick={() => handleDeleteProduct(item.id)}
                    >
                      Delete
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        ):(<div></div>)}
      </Card>
      <Card className="mt-2 border">
        <div className="mx-auto px-4 py-5 flex justify-center shadow-lg rounded-md">
          <Pagination
            count={products?.products?.totalPages}
            color="primary"
            className=""
            onChange={handlePaginationChange}
            // value={page}
          />
        </div>
      </Card>
      <Dialog
        open={openMain}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        >
          <DialogContent>
           <DialogTitle id="alert-dialog-title">
              {"Add Main Image"}
          </DialogTitle>
          <TextField
              type="file"
              name="file"
              onChange={(event) => handleMainFile(event)}
              
            />
          <Button
            component="label"
            role={undefined}
            variant="contained"
            tabIndex={-1}
            onClick={handleMainImage}
            startIcon={<CloudUploadIcon />}
          >
            Upload Main Image
          </Button>
          <DialogActions>
            <Button onClick={handleCloseMain} autoFocus>
              Close
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Add Additional Image"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Product is save.
          </DialogContentText>
          
          <TextField
              type="file"
              name="file"
              onChange={(event) => handleMainFile(event)}
              multiple
            />
          <Button
            component="label"
            role={undefined}
            variant="contained"
            tabIndex={-1}
            onClick={handleAddImageFirst}
            startIcon={<CloudUploadIcon />}
          >
            Upload first Image
          </Button>
          <TextField
            autoFocus
            required
            margin="dense"
            id="altstr1"
            name="altstr1"
            type="string"
            label="Alternate messages for first missing image."
            fullWidth
            variant="standard"
            value={productExtData.altstr1}
            onChange={handleChange}
          />
          {/*<TextField
              fullWidth
              label="Alternate messages for first missing image."
              name="altstr1"
              value={productExtData.altstr1}
              onChange={handleChange}
            />*/}

          <TextField
              type="file"
              onChange={(event) => handleMainFile(event)}
              multiple
            />
          <Button
            component="label"
            role={undefined}
            variant="contained"
            tabIndex={-1}
            onClick={handleAddImageSecond}
            startIcon={<CloudUploadIcon />}
          >
            Upload second Image
          </Button>
          <TextField
            autoFocus
            required
            margin="dense"
            id="altstr2"
            name="altstr2"
            type="string"
            label="Alternate messages for second missing image."
            fullWidth
            variant="standard"
            value={productExtData.altstr2}
            onChange={handleChange}
          />
           {/*<TextField
              fullWidth
              label="Alternate messages for first missing image."
              name="altstr2"
              value={productExtData.altstr2}
              onChange={handleChange}
            />*/}
            <TextField
              type="file"
              onChange={(event) => handleMainFile(event)}
              multiple
            />
          <Button
            component="label"
            role={undefined}
            variant="contained"
            tabIndex={-1}
            onClick={handleAddImageThird}
            startIcon={<CloudUploadIcon />}
          >
            Upload third Image
          </Button>
          <TextField
            autoFocus
            required
            margin="dense"
            id="altstr3"
            name="altstr3"
            type="string"
            label="Alternate messages for third missing image."
            fullWidth
            variant="standard"
            value={productExtData.altstr3}
            onChange={handleChange}
          />
           {/*<TextField
              fullWidth
              label="Alternate messages for first missing image."
              name="altstr3"
              value={productExtData.altstr3}
              onChange={handleChange}
            />*/}
          <TextField
              type="file"
              onChange={(event) => handleMainFile(event)}
              multiple
            />
          <Button
            component="label"
            role={undefined}
            variant="contained"
            tabIndex={-1}
            onClick={handleAddImageFourth}
            startIcon={<CloudUploadIcon />}
          >
            Upload fourth Image
          </Button>
          <TextField
            autoFocus
            required
            margin="dense"
            id="altstr4"
            name="altstr4"
            type="string"
            label="Alternate messages for fourth missing image."
            fullWidth
            variant="standard"
            value={productExtData.altstr4}
            onChange={handleChange}
          />
           {/*<TextField
              fullWidth
              label="Alternate messages for first missing image."
              name="altstr4"
              value={productExtData.altstr4}
              onChange={handleChange}
            />*/}

        </DialogContent>
        <DialogActions>
          <Button onClick={handleSaveExtData} autoFocus>
            Save
          </Button>
          <Button onClick={handleClose} autoFocus>
            Close
          </Button>
        </DialogActions>
      </Dialog>
        
      <Dialog open={opendialog} onClose={handleDialogClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
            <DialogTitle id="alert-dialog-title">
            {"Image successfully uploaded"}
            </DialogTitle>
            <DialogActions>
                <Button onClick={handleDialogClose} autoFocus>
                    Ok
                </Button>
            </DialogActions>
      </Dialog>

    </Box>
  );
};

export default ProductsTable;
